import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  MeetingCancellationReasonRequest,
  MeetingCancellationReasonResponse,
  PageResponse,
} from '../models/meeting.model';

@Injectable({ providedIn: 'root' })
export class MeetingCancellationReasonApiService {
  private url = `${environment.apiUrl}api/meeting-cancellation-reasons`;
  constructor(private http: HttpClient) {}

  list(
    businessId: number,
    page = 0,
    size = 20
  ): Observable<PageResponse<MeetingCancellationReasonResponse>> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<MeetingCancellationReasonResponse>>(
      this.url,
      { params }
    );
  }

  listActive(
    businessId: number
  ): Observable<MeetingCancellationReasonResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<MeetingCancellationReasonResponse[]>(
      `${this.url}/active`,
      { params }
    );
  }

  getById(
    id: number,
    businessId: number
  ): Observable<MeetingCancellationReasonResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<MeetingCancellationReasonResponse>(
      `${this.url}/${id}`,
      { params }
    );
  }

  create(
    body: MeetingCancellationReasonRequest
  ): Observable<MeetingCancellationReasonResponse> {
    return this.http.post<MeetingCancellationReasonResponse>(this.url, body);
  }

  update(
    id: number,
    businessId: number,
    body: MeetingCancellationReasonRequest
  ): Observable<MeetingCancellationReasonResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<MeetingCancellationReasonResponse>(
      `${this.url}/${id}`,
      body,
      { params }
    );
  }

  delete(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.url}/${id}`, { params });
  }
}
